import React from 'react';

import Header from '../Landing/HomeHeader';
import Footer from './Footer';

import image1 from 'assets/images/image1.svg';
import image2 from 'assets/images/image2.svg';
import image3 from 'assets/images/image3.svg';
import image4 from 'assets/images/image4.svg';

import cx from 'classnames';
import style from './AccountingFinancePayroll.module.scss';

export default function AccountingFinancePayroll() {
  return (
    <>
      <Header />
      <main className="typography">
        <section className={style.fundingSection}>
          <div className="bg-white">
            <div className="container">
              <div className={style.titleBox}>
                <h1 className="info-title">
                  <span className="black">end-to-end</span> funding
                  <div className={style.bgText}>end-to-end</div>
                </h1>
                <p className={style.caption}>
                  Solutions for Accounting, Payroll & Billing
                </p>
              </div>
              <div className={style.row}>
                <div className={style.col}>
                  <div className={style.card}>
                    <div className={style.cardIconWrapper}>
                      <span className="icon icon-envelope"></span>
                    </div>
                    <div className={style.cardText}>
                      <div className={style.accent}>70%</div>
                      of Staffing Agency Startups are unsuccessful
                    </div>
                  </div>
                </div>
                <div className={style.col}>
                  <div className={style.card}>
                    <div className={style.cardIconWrapper}>
                      <span className="icon icon-money2"></span>
                    </div>
                    <div className={style.cardText}>
                      <div className={style.accent}>4</div>
                      Outdated Funding Models All with Limited Solutions
                    </div>
                  </div>
                </div>
                <div className={style.col}>
                  <div className={style.card}>
                    <div className={style.cardIconWrapper}>
                      <span className="icon icon-sheet"></span>
                    </div>
                    <div className={style.cardText}>
                      <div className={style.accent}>47 days</div>
                      The average time it takes to receive payment for your
                      invoices
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className={style.content}>
              <h3 className="info-subtitle underline">
                Funding Staffing Business Operations is one of the biggest
                challenges an owner has… here are some common scenarios:
              </h3>
              <div>
                <div className={style.item}>
                  <div className={style.itemImg}>
                    <img src={image1} alt="" />
                  </div>
                  <div className={style.itemText}>
                    Sue struggles to meet weekly payroll funding requirements
                    for her workers while overseeing acceptable accounts
                    receivables terms and maintaining a solid collections
                    process.
                    <div className={style.itemCount}>01</div>
                  </div>
                </div>
                <div className={style.item}>
                  <div className={style.itemImg}>
                    <img src={image2} alt="" />
                  </div>
                  <div className={style.itemText}>
                    Connie is concerned about how to manage and reinvest cash
                    flow to take her firm to the next level after several years
                    of stagnant survival.
                    <div className={style.itemCount}>02</div>
                  </div>
                </div>
                <div className={style.item}>
                  <div className={style.itemImg}>
                    <img src={image3} alt="" />
                  </div>
                  <div className={style.itemText}>
                    Steve received a large headcount project. This should be an
                    exciting opportunity, but Steve grows concerned about the
                    logistics and significant funding required before seeing the
                    first payment a month and a half later.
                    <div className={style.itemCount}>03</div>
                  </div>
                </div>
              </div>
            </div>
            <h3 className={cx('info-subtitle underline', style.sizeSm)}>
              myBasePay is your Silver Bullet. we provide the Financial
              Infrastructure you need to support your Contingent workers, meet
              client demands and get paid faster.
            </h3>
            <div className={style.itemRow}>
              <div className={style.itemColSm}>
                <p>An All-Inclusive Funding Model:</p>
                <ul className="default-list rectangle">
                  <li>Credit Research</li>
                  <li>Complete Collections Ownership</li>
                  <li>Advanced Funding Options</li>
                  <li>Branded Invoices</li>
                  <li>
                    Financial Dashboard Analytics - no old school reporting
                  </li>
                </ul>
              </div>
              <div className={style.itemColXs}>
                <img src={image4} alt="" />
              </div>
            </div>
            <div className={style.contentWrapp}>
              <h3 className="info-subtitle underline">
                Mybasepay’s Advanced Payroll Model gives you payroll funding and
                commission every week payroll is processed.
              </h3>
              <p>
                Our proven Advanced Funding Process - We qualify, you get paid:
              </p>
              <ul className="default-list count">
                <li>
                  Submit a New Client <i className="icon icon-arrow"></i>{' '}
                  <strong>Complimentary Credit Check</strong>
                </li>
                <li>
                  Provide Project Details <i className="icon icon-arrow"></i>{' '}
                  <strong>Approve Funding Project </strong>
                </li>
                <li>
                  Ongoing Worker Payroll <i className="icon icon-arrow"></i>{' '}
                  <strong>Upfront Profit Commission</strong>
                </li>
                <li>
                  Proactive Communications <i className="icon icon-arrow"></i>{' '}
                  <strong>Collect receivables faster</strong>
                </li>
              </ul>
            </div>
          </div>
          <div className={cx('bg-white', style.content)}>
            <div className="container">
              <h3 className={cx('info-subtitle underline', style.sizeXs)}>
                Our model allows for staffing members to:
              </h3>
              <ul className="default-list rectangle">
                <li>Access companies with immediate staffing needs</li>
                <li>Reinvest capital into marketing to grow more sales</li>
                <li>Scale quicker than the competition</li>
              </ul>
              <p>
                Eliminate growth inhibitors in your back office{' '}
                <span className="icon icon-arrow"></span> Free up liquidity{' '}
                <span className="icon icon-arrow"></span> Invest in top sales
                and recruitment talent
              </p>
              <div className={style.leftLine}>
                Traditional staffing funding models are antiquated and
                inhibitive. The resulting process <strong>ONLY</strong> provides
                a solution to fund payroll and does not account for 100% of the
                invoiced amount.
              </div>
              <div className={style.table}>
                <table>
                  <thead>
                    <tr>
                      <th>Traditional Staffing Funding Options</th>
                      <th>Limited Liability</th>
                      <th>Upfront Profit</th>
                      <th>
                        No Reserves & <br /> Additional Fees
                      </th>
                      <th>
                        Interest Free <br /> 90-Days
                      </th>
                      <th>
                        Automated <br /> Funding Support
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Line of Credit</td>
                      <td></td>
                      <td></td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Factoring</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Self-Funded</td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td></td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Back Office Payroll Funding</td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td></td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td></td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>myBasePay Advanced Funding</td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                      <td>
                        <span className="icon icon-check"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className={cx(style.content, style.lastContent)}>
            <div className="container">
              <h3 className="info-subtitle underline">
                In a marketplace with limited funding options…
              </h3>
              <ul className="default-list count">
                <li>
                  <strong>Lines of Credit</strong> - Hefty application processes
                  are limited to a specified amount, leaving owners to manage
                  and request increases on their own during business spikes
                </li>
                <li>
                  <strong>Factoring</strong> - Owners rely on a system that
                  applies compounded interest rates beyond the set terms and
                  taps into cash reserves set aside by the factoring agency
                </li>
                <li>
                  <strong>Self Funded</strong> - The self-funded owner utilizes
                  the business's own cash reserves, which is likely to inhibit
                  growth
                </li>
                <li>
                  <strong>Back Office Payroll Funding</strong> - Although
                  liability is limited and payroll is covered, a business is
                  still set to wait the terms on the invoice receivables before
                  receiving payment
                </li>
              </ul>
              <h3 className="info-subtitle underline">
                We offer an advanced payment solution for a segmented
                marketplace:
              </h3>
              <ul className="default-list rectangle">
                <li>Weekly payroll for all worker types</li>
                <li>Up-front profit to our staffing and recruiting partners</li>
                <li>Paying 3rd party staffing partners on your behalf</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
